/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { MarketAsset } from 'src/config';

import heroSm from 'src/config/default/asset/landing/hero-sm-min.png';
import heroSmWebp from 'src/config/default/asset/landing/hero-sm-min.webp';

import heroMd from 'src/config/default/asset/landing/hero-md-min.png';
import heroMdWebp from 'src/config/default/asset/landing/hero-md-min.webp';

import heroLg from 'src/config/default/asset/landing/hero-lg-min.png';
import heroLgWebp from 'src/config/default/asset/landing/hero-lg-min.webp';

import testimonial from 'src/config/default/asset/landing/testimonial-min.png';
import testimonialWebp from 'src/config/default/asset/landing/testimonial-min.webp';

import values from 'src/config/default/asset/landing/values-min.png';
import valuesWebp from 'src/config/default/asset/landing/values-min.webp';

import expect1lg_circle from 'src/config/default/asset/landing/wte-1-US-lg-min.png';
import expect1lg_circle_webp from 'src/config/default/asset/landing/wte-1-US-lg-min.webp';

import expect1sm_circle from 'src/config/default/asset/landing/wte-1-US-sm-min.png';
import expect1sm_circle_webp from 'src/config/default/asset/landing/wte-1-US-sm-min.webp';

import expect2lg_circle from 'src/config/default/asset/landing/wte-2-US-lg-min.png';
import expect2lg_circle_webp from 'src/config/default/asset/landing/wte-2-US-lg-min.webp';

import expect2sm_circle from 'src/config/default/asset/landing/wte-2-US-sm-min.png';
import expect2sm_circle_webp from 'src/config/default/asset/landing/wte-2-US-sm-min.webp';

import expect3lg_circle from 'src/config/default/asset/landing/wte-3-US-lg-min.png';
import expect3lg_circle_webp from 'src/config/default/asset/landing/wte-3-US-lg-min.webp';

import expect3sm_circle from 'src/config/default/asset/landing/wte-3-US-sm-min.png';
import expect3sm_circle_webp from 'src/config/default/asset/landing/wte-3-US-sm-min.webp';

const asset: MarketAsset = {
  landing: {
    heroSm,
    heroSmWebp,
    heroMd,
    heroMdWebp,
    heroLg,
    heroLgWebp,
    testimonial,
    testimonialWebp,
    values,
    valuesWebp,
    expect1lg: expect1lg_circle,
    expect1lgWebp: expect1lg_circle_webp,
    expect1sm: expect1sm_circle,
    expect1smWebp: expect1sm_circle_webp,
    expect2lg: expect2lg_circle,
    expect2lgWebp: expect2lg_circle_webp,
    expect2sm: expect2sm_circle,
    expect2smWebp: expect2sm_circle_webp,
    expect3lg: expect3lg_circle,
    expect3lgWebp: expect3lg_circle_webp,
    expect3sm: expect3sm_circle,
    expect3smWebp: expect3sm_circle_webp
  }
};

export default asset;
